import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

const searchSchema = z.object({
  tab: z.enum(["pickup", "proposal", "addonOrder"]).optional(),
})

export const Route = createFileRoute(
  "/(app)/_auth/settings/communication/reminders",
)({
  validateSearch: searchSchema,
  loader: () => ({
    crumb: "alfred.settings.nav.communicationReminders.label",
  }),
})
